export const ESSENCE_CUSTOMER_ID = 'Cust-1902427';
